type UtmPlace = 'mainsite' | 'ubercatalog';
export const getUtmQueryString = (place: UtmPlace) => {
  const utmCampaign = place === 'ubercatalog' ? 'ubercatalog_product_card' : 'mainsite_retailers_block';
  return `referrer=zakaz&utm_source=zakaz_${place}&utm_medium=referral&utm_campaign=${utmCampaign}`;
};
